import { defineComponent as n, createBlock as c, openBlock as r, unref as a, mergeProps as l, withCtx as m, createElementVNode as p } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const u = /* @__PURE__ */ n({
  name: "IconGlobe",
  __name: "IconGlobe",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (i, e) => (r(), c(a(s), l(t, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        p("path", {
          "fill-rule": "evenodd",
          d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25M8.898 4.353A8.28 8.28 0 0 0 4.65 8.25h2.733c.33-1.538.854-2.877 1.515-3.897M4.06 9.75A8.256 8.256 0 0 0 3.75 12a8.246 8.246 0 0 0 .386 2.5h3.03A18.635 18.635 0 0 1 7 12a18.74 18.74 0 0 1 .134-2.25H4.06M4.783 16a8.281 8.281 0 0 0 4.115 3.647C8.273 18.682 7.77 17.433 7.438 16H4.784m10.32 3.647A8.281 8.281 0 0 0 19.216 16H16.56c-.33 1.433-.834 2.682-1.459 3.647m4.761-5.147A8.244 8.244 0 0 0 20.25 12a8.26 8.26 0 0 0-.31-2.25h-3.074A18.738 18.738 0 0 1 17 12a18.64 18.64 0 0 1-.166 2.5h3.03M19.35 8.25h-2.733c-.33-1.538-.854-2.877-1.515-3.897A8.28 8.28 0 0 1 19.35 8.25M12 3.75c.526 0 1.385.449 2.2 2.04.355.69.656 1.522.88 2.46H8.92C9.145 7.312 9.446 6.48 9.8 5.79c.814-1.59 1.673-2.04 2.2-2.04m2.2 14.46A10.76 10.76 0 0 0 15.018 16H8.983a10.762 10.762 0 0 0 .816 2.21c.816 1.591 1.675 2.04 2.201 2.04s1.385-.449 2.2-2.04M15.5 12c0 .877-.064 1.715-.18 2.5H8.68A17.03 17.03 0 0 1 8.5 12c0-.784.051-1.538.146-2.25h6.708A17.165 17.165 0 0 1 15.5 12",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
